export default __webpack_public_path__ + "static/media/cross-circle.aec6d82f.svg";